import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

import { withStyles } from "@material-ui/core/styles";
import ButtonBase from "@material-ui/core/ButtonBase";

const styles = (theme) => ({
    buttonRootStyle: {
        backgroundColor: "#303c49",
        height: 80,
        width: 239,
        marginRight: 4,
    },
    labelContainerStyle: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        paddingBottom: 10,
        paddingLeft: 10,
    },
    iconContainerStyle: {
        paddingRight: 3,
        paddingBottom: 3,
    },
    triangleStyle: {
        width: 0,
        height: 0,
        borderBottom: "18px solid #e40045",
        borderLeft: "18px solid transparent",
    },
    contentContainerStyle: {
        fontFamily: "MANEurope, Arial, sans-serif",
        fontSize: theme.typography.pxToRem(19),
        fontWeight: "bold",
        lineHeight: 1.05,
        fontStretch: "condensed",
        color: "#fafafa",
        display: "flex",
        flex: "1 0 auto",
        height: 80,
        justifyContent: "space-between",
        alignItems: "flex-end",
        textDecoration: "none",
    },
});

const TopicClusterTopicButton = ({
    classes: { buttonRootStyle, labelContainerStyle, iconContainerStyle, triangleStyle, contentContainerStyle },
    label = "",
    location,
}) => {
    const [firstPart, secondPart] = label.split("&");
    return (
        <ButtonBase focusRipple className={buttonRootStyle} component={Link} to={location}>
            <div className={contentContainerStyle}>
                <div className={labelContainerStyle}>
                    <div>{firstPart}&</div>
                    <div>{secondPart}</div>
                </div>
                <div className={iconContainerStyle}>
                    <div className={triangleStyle} />
                </div>
            </div>
        </ButtonBase>
    );
};

TopicClusterTopicButton.propTypes = {
    label: PropTypes.string.isRequired,
    location: PropTypes.string.isRequired,
};

export default withStyles(styles)(TopicClusterTopicButton);



// WEBPACK FOOTER //
// ./src/components/TopicClusterTopicButton.js